export default __webpack_public_path__ + "30e6e07e9a494626ed53ce458754a942.svg";